export default "__VITE_ASSET__DSSA9jvx__"